import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

export default function SingleSelect({
  options,
  selectedOption,
  setSelectedOption,
  readOnly,
}) {
  const selectedValue = selectedOption?.id || "";

  return (
    <FormControl fullWidth>
      <Select
        readOnly={readOnly}
        disabled={readOnly}
        value={selectedValue}
        onChange={(e) => {
          const selectedId = e.target.value;
          const option = options.find((opt) => opt.id === selectedId);
          setSelectedOption(option || null);
        }}
        displayEmpty
        variant="standard"
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.display || ""}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

